/* @flow */
import * as React from 'react';

type Props = {
  element: React.Element<any>,
};

function HoverCell({ element }: Props) {
  return <div className="ComposableTable-hoverCell">{element}</div>;
}

export function wrapInHoverCell(generator: Function) {
  return (input: Object) => {
    return <HoverCell element={generator(input)} />;
  };
}
